import { FamilyApplicationEndpoints } from '@/apis/family_application/requests'
import { parseRequestError } from '@/app/common/utilities'
import axiosInstance from '@/libs/axios_config'
import { useMutation } from '@tanstack/react-query'
import { z } from 'zod'

const PostBCResponseSchema = z.object({
  date_of_birth: z.string(),
  student_document_id: z.number(),
})

export type PostBCResponse = z.infer<typeof PostBCResponseSchema>

// Define the custom hook
export const usePostBirthCertificate = () => {
  return useMutation<PostBCResponse, Error, FormData>({
    mutationFn: async (payload: FormData) => {
      try {
        const response = await axiosInstance.post(
          FamilyApplicationEndpoints.post_birth_certificate,
          payload,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        )
        return PostBCResponseSchema.parse(response.data)
      } catch (error) {
        throw parseRequestError(error)
      }
    },
  })
}
